@if (scores() && totalCount() > 0) {
  <div
    class="compliance-graph"
    [class.standalone]="standalone()"
  >
    <div class="items">
      <div
        class="item fulfilled"
        [style.width.%]="(fulfilledCount() / totalCount()) * 100"
        [matTooltip]="`Fulfilled (${fulfilledCount()}/${totalCount()})`"
      ></div>
      <div
        class="item for-clarification"
        [style.width.%]="(forClarificationCount() / totalCount()) * 100"
        [matTooltip]="`For Clarification (${forClarificationCount()}/${totalCount()})`"
      ></div>
      <div
        class="item unfulfilled"
        [style.width.%]="(unselectedCount() / totalCount()) * 100"
        [matTooltip]="`Unfulfilled (${unselectedCount()}/${totalCount()})`"
      ></div>
    </div>
  </div>
  <div class="scores">
    <div class="score">
      <span class="badge fulfilled"></span>
      {{ fulfilledCount() }}
    </div>
    <div class="score">
      <span class="badge for-clarification"></span>
      {{ forClarificationCount() }}
    </div>
    <div class="score">
      <span class="badge unfulfilled"></span>
      {{ unselectedCount() }}
    </div>
  </div>
} @else {
  -
}
